export const asset = (path: string) => `https://smartdrain.network${path}`
export const localAsset = (path: string) => path

export const livePlatformUrl = "https://smartdrain.info"
export const smartDrainWorksVideo = "https://www.youtube.com/embed/zJMRJb5Emxs"

export const kolonnawaMedia = {
  overview: localAsset("/media/kolonnawa/kolonnawa-overview.jpg"),
  blockedDrain: localAsset("/media/kolonnawa/kolonnawa-blocked-drain.jpeg"),
  iotMonitor: localAsset("/media/kolonnawa/kolonnawa-iot-monitor.png"),
  capturedLitter: localAsset("/media/kolonnawa/kolonnawa-captured-litter.jpg"),
  capturedLitterWide: localAsset("/media/kolonnawa/kolonnawa-captured-litter-wide.jpg"),
  inspection: localAsset("/media/kolonnawa/kolonnawa-inspection.jpg"),
  clearDrain: localAsset("/media/kolonnawa/kolonnawa-clear-drain.jpg"),
  fieldVideo: localAsset("/media/kolonnawa/kolonnawa-field-video.mp4"),
  fieldVideoPoster: localAsset("/media/kolonnawa/kolonnawa-field-video-poster.jpg"),
  completedInstallation: localAsset("/media/deployments/kolonnawa-completed-installation.jpg"),
}

export const productMedia = {
  inletFilter1: localAsset("/media/products/inlet-filter-1.png"),
  inletFilter2: localAsset("/media/products/inlet-filter-2.png"),
  openDrain1: localAsset("/media/products/open-drain-retrofit-1.jpeg"),
  openDrain2: localAsset("/media/products/open-drain-retrofit-2.jpeg"),
  dualLayerOpenDrain1: localAsset("/media/products/dual-layer-open-drain-1.jpg"),
  dualLayerOpenDrain2: localAsset("/media/products/dual-layer-open-drain-2.jpg"),
  brisbaneWasteFill: localAsset("/media/products/brisbane-design-waste-fill.jpg"),
  openDrainStreet: localAsset("/media/products/open-drain-retrofit-street.jpg"),
}

export const developmentMedia = {
  initial2014: localAsset("/media/development/2014_Initial-Design-and-Development.jpg"),
  invention2016: localAsset("/media/development/2016_International-Invention-and-Innovation-Exhibition-Kuala-Lumpur.jpg"),
  phd2017: localAsset("/media/development/2017_PhD.jpg"),
  patent2022: localAsset("/media/development/2022_Patent.jpeg"),
  goodDesign2024: localAsset("/media/development/2024_Good-Design.jpg"),
  shenzhen2025: localAsset("/media/development/2025-Shenzhen-Innovation-Entrepreneurship-Competition.jpg"),
  wipo2025: localAsset("/media/development/WIPO-Global-Award.jpeg"),
  mou2025: localAsset("/media/development/Signing-of-MOU_NDA-2.jpeg"),
  colomboDevelopment: localAsset("/media/development/Colombo-Development.jpg"),
}

export const evidenceMedia = {
  fieldConsultation: localAsset("/media/evidence/field-consultation-workers.jpeg"),
  lzbMetalPartnership: localAsset("/media/evidence/lzb-metal-partnership.jpg"),
  lzbMetalPartnershipPortrait: localAsset("/media/evidence/lzb-metal-partnership-portrait.jpg"),
  monsoonCanalClogging: localAsset("/media/evidence/monsoon-canal-clogging.jpg"),
  monsoonCanalCloggingWide: localAsset("/media/evidence/monsoon-canal-clogging-wide.png"),
  openDrainWasteAccumulation: localAsset("/media/evidence/open-drain-waste-accumulation.png"),
  fieldDrainSite1: localAsset("/media/evidence/field-drain-site-1.jpg"),
  fieldDrainSite2: localAsset("/media/evidence/field-drain-site-2.jpg"),
  fieldInspection7281: localAsset("/media/evidence/field-inspection-7281.jpg"),
  fieldInspection7286: localAsset("/media/evidence/field-inspection-7286.jpg"),
  fieldInspection7289: localAsset("/media/evidence/field-inspection-7289.jpg"),
  fieldInspection7291: localAsset("/media/evidence/field-inspection-7291.jpg"),
}

export const teamMedia = {
  nadeesha: localAsset("/media/team/CHANDRASENA_Nadeesha_SMART-DRAIN_Headshot_.jpeg"),
  asha: localAsset("/media/team/asha-lokuwaduge.jpg"),
  madusha: localAsset("/media/team/Madusha.jpeg"),
  deon: localAsset("/media/team/Deon-Joshua.jpg"),
  clarence: localAsset("/media/team/Clarence-Tan-(2).jpeg"),
  pasindu: localAsset("/media/team/pasindu.jpg"),
  ramesh: localAsset("/media/team/ramesh.jpeg"),
  leila: localAsset("/media/team/leila-alem.jpg"),
  nusaike: localAsset("/media/team/nusaike-mufthie.jpg"),
  varuna: localAsset("/media/team/varuna-perera.jpg"),
}

export const partnerLogos = {
  access: localAsset("/media/partners/Access-logo-png.png"),
  bable: localAsset("/media/partners/Black_Digital.png"),
  sheWins: localAsset("/media/partners/MSC_logo.png"),
  uqVentures: localAsset("/media/partners/uq-logo-purple.png"),
  energyLab: localAsset("/media/partners/EnergyLab_Startup_Badge_Black.png"),
}

export const navigation = [
  { label: "Technology", href: "/technology" },
  { label: "Products", href: "/products" },
  { label: "Deployments", href: "/deployments" },
  { label: "Development", href: "/development" },
  { label: "Team", href: "/team" },
  { label: "About", href: "/about" },
  { label: "Blog", href: "/blog" },
]

export const awards = [
  { title: "ClimateLaunchpad Australia National Winner", year: "2026", note: "National winner, recognising Smart Drain as a scalable climate-tech solution.", href: "https://www.instagram.com/p/DbW4SIGhjDK/" },
  { title: "WIPO Global Award Winner", year: "2025", note: "Environment category for startups.", href: "https://www.wipo.int/en/web/awards/global/2025" },
  { title: "Australian Good Design Award", year: "2024", note: "Best in Class — Engineering Design.", href: "https://good-design.org/projects/solid-waste-clog-resistant-smart-drain/" },
  { title: "Patent No. 21267", year: "2022", note: "Intellectual Property Office of Sri Lanka." },
]

export type ProductItem = {
  slug: string
  title: string
  kicker: string
  description: string
  bullets: string[]
  image: string
  secondaryImage?: string
}

export const products: ProductItem[] = [
  {
    slug: "Catch Litter Before It Enters the Network.",
    title: "Catch Litter Before It Enters the Network.",
    kicker: "Roadside & grated stormwater inlets",
    description:
      "Retrofit existing drain inlets with a Smart Drain filter that captures waste at the source, while IoT monitoring provides visibility of fill level and water level for smarter maintenance.",
    bullets: ["Defensible IP", "Retrofit infrastructure", "Built to scale across cities"],
    image: productMedia.inletFilter1,
    secondaryImage: productMedia.inletFilter2,
  },
  {
    slug: "Stop Litter Where It Builds Up.",
    title: "Stop Litter Where It Builds Up.",
    kicker: "Open drains & hotspot sections",
    description:
      "Retrofit existing open drains at recurring hotspots. Intercept waste before it moves downstream, maintain flow and reduce repeated cleaning.",
    bullets: [],
    image: productMedia.openDrain1,
    secondaryImage: productMedia.openDrain2,
  },
  {
    slug: "Build Litter Control Into the Drain.",
    title: "Build Litter Control Into the Drain.",
    kicker: "Designed for new construction projects",
    description:
      "Designed for new developments, the dual-layer system intercepts debris at surface and subsurface levels while maintaining stormwater conveyance.",
    bullets: [],
    image: productMedia.dualLayerOpenDrain1,
    secondaryImage: productMedia.dualLayerOpenDrain2,
  },
]

export const outcomes = [
  { title: "Reduce blockages", body: "Intercept litter and debris before they restrict stormwater flow." },
  { title: "Reduce flood risk", body: "Keep drains flowing and identify abnormal water-level conditions earlier." },
  { title: "Reduce maintenance", body: "Target inspections and cleaning where they are actually needed." },
  { title: "Protect waterways", body: "Capture plastics and litter before they travel into canals, rivers and oceans." },
]

export const audiences = [
  { title: "Cities & Councils", body: "Upgrade clog-prone drainage hotspots and improve visibility across stormwater networks." },
  { title: "Property & Precinct Owners", body: "Reduce drainage blockages and litter discharge across large properties and developments." },
  { title: "Infrastructure Operators", body: "Add preventative maintenance and monitoring capability to existing drainage assets." },
  { title: "Developers & Engineers", body: "Integrate smarter drainage into new developments and retrofit projects." },
]

export const resources = [
  {
    title: "Patent File",
    description: "The Solid Waste Clog-Resistant Storm Drain was patented at the Intellectual Property Office of Sri Lanka on February 23, 2022, under patent number 21267.",
    href: "https://531-2-smart-drain-storage.sgp1.digitaloceanspaces.com/resources/patent-certificate.pdf",
    type: "PDF",
  },
  {
    title: "Product Flyer",
    description: "A concise technical overview of the Solid Waste Clog-Resistant Storm Drain.",
    href: "https://531-2-smart-drain-storage.sgp1.digitaloceanspaces.com/resources/flyer.pdf",
    type: "PDF",
  },
  {
    title: "Technical Presentation",
    description: "Technical slides from Nadeesha Chandrasena's PhD viva voce examination, presented on May 15, 2017.",
    href: "https://531-2-smart-drain-storage.sgp1.digitaloceanspaces.com/resources/technical-presentation.ppt",
    type: "PPT",
  },
  {
    title: "Research TOR",
    description: "Terms of Reference for Smart Drain retrofit pilot research in Colombo and Kandy, including IoT monitoring, research and implementation roles.",
    href: "https://531-2-smart-drain-storage.sgp1.digitaloceanspaces.com/resources/tor-smartdrain-pilot-tests-colombo-kandy.pdf",
    type: "PDF",
  },
]

export const team = [
  {
    name: "Nadeesha Chandrasena",
    role: "Founder & Inventor",
    image: teamMedia.nadeesha,
    bio: "An expert in urban water management, Dr. Chandrasena drives the vision behind Smart Drain, focusing on solutions that prevent urban flooding and reduce pollution in waterways.",
    linkedin: "https://www.linkedin.com/in/nadeesha-chandrasena",
  },
  {
    name: "Asha Lokuwaduge",
    role: "Co-Founder",
    image: teamMedia.asha,
    bio: "Asha Lokuwaduge is a CPA with more than 22 years of experience in accounting, financial management and business reporting. She brings strong expertise in financial governance, commercial decision-making and sustainable finance, alongside senior industry experience in Australia.",
    linkedin: "https://www.linkedin.com/in/asha-lokuwaduge-8a2b0219",
  },
  {
    name: "Dr Leila Alem",
    role: "Go-to-Market Strategist",
    image: teamMedia.leila,
    bio: "Dr Leila Alem is an innovation strategist and scientist with more than 25 years of experience helping organisations turn complex ideas into impactful products and services. She brings deep expertise in innovation, emerging technologies, Design Thinking, Lean Startup and entrepreneurship, with experience across industry, research and the startup ecosystem.",
    linkedin: "https://www.linkedin.com/in/leilaalem",
  },
  {
    name: "Ramesh Lakshan",
    role: "Lead IoT Engineer",
    image: teamMedia.ramesh,
    bio: "Leads the IoT engineering effort, designing and deploying the sensor systems and connectivity solutions that power Smart Drain's real-time monitoring.",
    linkedin: "https://www.linkedin.com/in/ramesh-lakshan-b38504269",
  },
  {
    name: "Madusha Namudara",
    role: "Design Engineer",
    image: teamMedia.madusha,
    bio: "With expertise in engineering design, Madusha ensures Smart Drain is structurally durable, efficient, and adaptable for real-world implementation.",
    linkedin: "https://www.linkedin.com/in/madusha-namudara-b998a81bb",
  },
  {
    name: "Pasindu Dilhara Weerasuriya",
    role: "Senior Software Engineer",
    image: teamMedia.pasindu,
    bio: "A senior software engineer contributing to Smart Drain's digital platform, data systems and application development.",
    linkedin: "https://www.linkedin.com/in/pasindu-dilhara-082486188",
  },
  {
    name: "Dr Clarence Tan",
    role: "Strategic Advisor",
    image: teamMedia.clarence,
    bio: "Dr Clarence Tan is an inventor, technologist and global keynote speaker who brings expertise in AI, innovation and social-impact entrepreneurship.",
    linkedin: "https://www.linkedin.com/in/drctan",
  },
  {
    name: "Deon Joshua",
    role: "Citizen Science and Data Innovation Associate",
    image: teamMedia.deon,
    bio: "Deon is a tech entrepreneur with expertise in web systems, data science and machine learning, helping build Smart Drain's digital innovation layer.",
    linkedin: "https://www.linkedin.com/in/deon-joshua",
  },
  {
    name: "Nusaike Mufthie",
    role: "Consultant, IP Commercialisation",
    image: teamMedia.nusaike,
    bio: "Nusaike turns ideas into opportunities. His expertise spans innovation management, intellectual property, technology transfer, business, and strategy. He is passionate about bridging academia, industry, and government to transform research into market ready innovations that drive economic and societal impact.",
    linkedin: "https://www.linkedin.com/in/nusaikemufthie",
  },
  {
    name: "Varuna Perera",
    role: "Digital Media & Growth Advisor",
    image: teamMedia.varuna,
    bio: "Varuna Perera is a digital media enthusiast with strong experience in digital marketing, branding, and online growth. He advises Urban Inventors on scaling the Smart Drain brand through digital media, marketing, e-commerce, and online platforms. He brings a practical, growth-focused approach to building visibility, engagement, and market reach.",
    linkedin: "https://www.linkedin.com/in/varunaperera",
  },
]

export type PartnerItem = {
  name: string
  role: string
  description: string
  href: string
  logo?: string
}

export const partners: PartnerItem[] = [
  { name: "Access Engineering PLC", role: "Engineering & deployment partner", description: "Supports engineering collaboration and field deployment in Sri Lanka.", href: "https://accessengsl.com", logo: partnerLogos.access },
  { name: "BABLE Smart Cities", role: "Market-entry partner", description: "Supports European market entry, city pipeline development and go-to-pilot activity.", href: "https://www.bable-smartcities.eu", logo: partnerLogos.bable },
  { name: "IFC She Wins Climate South Asia", role: "Regional climate ecosystem", description: "Connected Smart Drain with climate innovators, partners and potential adopters across the region.", href: "https://www.ifc.org", logo: partnerLogos.sheWins },
]

export const ecosystemSupport: PartnerItem[] = [
  { name: "UQ Ventures", role: "Accelerator", description: "Accelerated through the UQ Ventures ilab Accelerator, Cohort 4.", href: "https://ventures.uq.edu.au/", logo: partnerLogos.uqVentures },
  { name: "UniQuest", role: "Commercialisation ecosystem", description: "Supported through the UQ Ventures ilab Accelerator ecosystem.", href: "https://uniquest.com.au/" },
  { name: "EnergyLab", role: "Investment readiness", description: "Completed the Climate Tech Investment Ready Program — Queensland.", href: "https://energylab.org.au/", logo: partnerLogos.energyLab },
]

export const deploymentSites = [
  {
    city: "Kolonnawa",
    site: "Wadullawatta / Orugodawatta Urban Drainage Corridor",
    status: "Completed municipal project — 2026",
    problem:
      "A high-density urban area affected by frequent litter accumulation and drain clogging across an approximately 90 m drainage section.",
    intervention:
      "Smart Drain was installed to intercept plastic, organic waste and other debris before they travel further through the drainage network, while IoT monitoring provides real-time drainage-condition information.",
    evidence: "At one hotspot, 32 kg of plastic and organic waste was captured in a single week while stormwater flow was maintained.",
    heroImage: kolonnawaMedia.completedInstallation,
    video: kolonnawaMedia.fieldVideo,
    videoPoster: kolonnawaMedia.fieldVideoPoster,
    gallery: [kolonnawaMedia.completedInstallation, kolonnawaMedia.clearDrain, kolonnawaMedia.inspection, kolonnawaMedia.iotMonitor],
    focus: ["Litter interception", "Clog prevention", "Real-time monitoring", "Urban flood-risk reduction"],
  },
]

export const pilotCities = [
  ["Kolonnawa Urban Council 2026", "Field implementation"],
  ["Bangalore Climate Data Week 2026", "Regional showcase"],
  ["Ambalangoda, Sri Lanka", "Pilot Implementation 2024"],
  ["Australia, 2027", "Commercial Product Development"],
] as const

export type MilestoneItem = {
  year: string
  title: string
  body: string
  image?: string
}

export const milestones: MilestoneItem[] = [
  { year: "2026", title: "Taking Smart Drain to South Asia", body: "Smart Drain was showcased in Bangalore, India and completed the She Wins Climate South Asia cohort, connecting with climate innovators, partners and potential adopters across the region." },
  { year: "2026", title: "ClimateLaunchpad Australia National Winner", body: "Smart Drain was named ClimateLaunchpad Australia National Winner 2026, recognising its potential as a scalable climate-tech solution." },
  { year: "2026", title: "First field implementation", body: "Initial field implementation launched at Wadullawatta in the Kolonnawa Urban Council area, bringing Smart Drain into a live municipal drainage environment.", image: kolonnawaMedia.completedInstallation },
  { year: "2026", title: "UQ Ventures iLab — Cohort 4", body: "Completed UQ Ventures iLab Cohort 4, supporting product development, commercialisation and startup growth." },
  { year: "2026", title: "EnergyLab Investment Readiness", body: "Completed the EnergyLab Investment Readiness Program, strengthening Smart Drain's investment strategy and pathway to market." },
  { year: "2025", title: "WIPO Global Award", body: "Smart Drain by Urban Inventors won the WIPO Global Award 2025 in the Environment category for startups.", image: developmentMedia.wipo2025 },
  { year: "2025", title: "Shenzhen Innovation & Entrepreneurship Competition", body: "Global recognition helped strengthen Smart Drain's international visibility and innovation pathway.", image: developmentMedia.shenzhen2025 },
  { year: "2025", title: "MOU / NDA and deployment partnership development", body: "Partnership discussions and formal engagement helped move Smart Drain from recognition toward field collaboration and practical implementation.", image: developmentMedia.mou2025 },
  { year: "2024", title: "Australian Good Design Awards", body: "Smart Drain received Best in Class in Engineering Design and a Gold Accolade at the Australian Good Design Awards.", image: developmentMedia.goodDesign2024 },
  { year: "2024–2023", title: "Product commissioning and field learning", body: "Early commissioning and field-development work translated the patented concept into a deployable retrofit system for real drainage environments.", image: developmentMedia.colomboDevelopment },
  { year: "2022", title: "Patent protection", body: "Patent No. 21267 was granted in Sri Lanka, protecting the Solid Waste Clog-Resistant Storm Drain.", image: developmentMedia.patent2022 },
  { year: "2017", title: "PhD research milestone", body: "Doctoral research and technical validation strengthened the scientific and engineering basis for Smart Drain.", image: developmentMedia.phd2017 },
  { year: "2016", title: "International invention showcase", body: "The technology was showcased at the International Invention and Innovation Exhibition in Kuala Lumpur.", image: developmentMedia.invention2016 },
  { year: "2014", title: "Initial design and development", body: "Early design work laid the foundation for the retrofit-first drainage concept that later evolved into Smart Drain.", image: developmentMedia.initial2014 },
]

export type GalleryItem = {
  category: "Field" | "Videos" | "Graphics"
  title: string
  image: string
  video?: string
}

export const gallery: GalleryItem[] = [
  { category: "Field", title: "Completed installation", image: kolonnawaMedia.completedInstallation },
  { category: "Field", title: "Blocked drain conditions", image: kolonnawaMedia.blockedDrain },
  { category: "Field", title: "IoT monitoring unit in the drain", image: kolonnawaMedia.iotMonitor },
  { category: "Field", title: "Inspection and maintenance access", image: kolonnawaMedia.inspection },
  { category: "Field", title: "Flow path after interception", image: kolonnawaMedia.clearDrain },
  { category: "Field", title: "Captured litter at the retrofit", image: kolonnawaMedia.capturedLitter },
  { category: "Videos", title: "Kolonnawa field walkthrough", image: kolonnawaMedia.fieldVideoPoster, video: kolonnawaMedia.fieldVideo },
  { category: "Graphics", title: "Inlet filter render", image: productMedia.inletFilter1 },
  { category: "Field", title: "Municipal maintenance crew field consultation", image: evidenceMedia.fieldConsultation },
  { category: "Field", title: "Monsoon canal stormwater blockage hotspot", image: evidenceMedia.monsoonCanalClogging },
  { category: "Field", title: "Confined drain solid waste accumulation", image: evidenceMedia.openDrainWasteAccumulation },
  { category: "Graphics", title: "Manufacturing partnership with LZB Metal", image: evidenceMedia.lzbMetalPartnership },
]

export const evidencePhotos = [
  {
    title: "Field consultation with municipal sanitation crews",
    subtitle: "Kolonnawa Urban Council, Sri Lanka",
    description: "Direct on-ground discussions with municipal maintenance workers in wet-weather conditions to evaluate debris loading, cleaning frequency, and manual maintenance hazards.",
    category: "Field Notes",
    image: evidenceMedia.fieldConsultation,
    date: "October 2026",
    link: "/blog/field-evidence-sanitation-workers-and-monsoon-drainage",
  },
  {
    title: "Global manufacturing partnership with LZB Metal",
    subtitle: "Urban Inventors (Australia) & LZB Metal (China)",
    description: "Precision metal manufacturing collaboration enabling large-scale, cost-effective production of patented Smart Drain interception filters and retrofit frames.",
    category: "Manufacturing",
    image: evidenceMedia.lzbMetalPartnership,
    date: "April 2026",
    link: "/blog/manufacturing-partnership-urban-inventors-and-lzb-metal",
  },
  {
    title: "Severe open canal plastic and organic debris accumulation",
    subtitle: "Urban stormwater drainage hotspot",
    description: "Massive solid waste accumulation choking an open municipal stormwater channel during rainfall, demonstrating the critical need for upstream retrofit interception.",
    category: "Field Evidence",
    image: evidenceMedia.monsoonCanalClogging,
    date: "July 2026",
    link: "/blog/monsoon-runoff-and-open-canal-waste-interception",
  },
  {
    title: "Secondary drainage channel solid waste bottleneck",
    subtitle: "Confined concrete surface stormwater channel",
    description: "Dense plastic and packaging waste blocking a secondary surface drain before subsurface entry, proving why source interception protects underground conduits.",
    category: "Field Notes",
    image: evidenceMedia.openDrainWasteAccumulation,
    date: "July 2026",
    link: "/blog/secondary-drainage-channels-preventing-subsurface-debris-buildup",
  },
]

export const blogPosts = [
  {
    slug: "field-evidence-sanitation-workers-and-monsoon-drainage",
    title: "Field notes: consulting municipal drainage teams during monsoon runoff",
    excerpt: "Direct field observations with municipal maintenance crews reveal how rapid solid waste accumulation overwhelms standard drainage networks during heavy rainfall.",
    date: "October 8, 2026",
    readTime: "5 min read",
    category: "Field Evidence",
    image: evidenceMedia.fieldConsultation,
    content: [
      "Understanding urban drainage failure requires spending time where maintenance teams actually operate — in flooded streets, beside congested stormwater grates, and during active monsoon rainfall.",
      "During our field consultations with municipal sanitation teams in Sri Lanka, workers described the relentless cycle of manually clearing debris from open drains only to have them choke again hours later during heavy downpours. Without upstream catchment filters, maintenance is perpetually reactive and dangerous for crews.",
      "Integrating Smart Drain's patented interception mechanism with IoT fill-level sensors directly addresses this pain point, shifting city operations from exhausting manual crisis intervention to scheduled, data-informed maintenance.",
    ],
  },
  {
    slug: "manufacturing-partnership-urban-inventors-and-lzb-metal",
    title: "Manufacturing partnership: Urban Inventors and LZB Metal join forces",
    excerpt: "Scaling Smart Drain production through advanced metal fabrication and global supply chain partnerships between Australia and China.",
    date: "October 4, 2026",
    readTime: "4 min read",
    category: "Manufacturing",
    image: evidenceMedia.lzbMetalPartnership,
    content: [
      "To scale climate infrastructure across global cities, world-class engineering design must be paired with precision, high-capacity manufacturing capabilities.",
      "Urban Inventors has partnered with LZB Metal, China, to manufacture the patented Smart Drain filter units and stormwater interception systems. This partnership combines Australian engineering ingenuity and award-winning design with deep manufacturing excellence in heavy-duty corrosion-resistant metals.",
      "Backed by our Australian Good Design Best in Class and WIPO Global Award recognitions, this collaboration guarantees the production quality and volume required for municipal rollouts across Australia, South Asia, and beyond.",
    ],
  },
  {
    slug: "monsoon-runoff-and-open-canal-waste-interception",
    title: "Canal clogging under monsoon conditions: the case for source interception",
    excerpt: "Visual evidence of floating plastic choking stormwater corridors shows why downstream clearing alone cannot prevent urban drainage blockages.",
    date: "September 28, 2026",
    readTime: "6 min read",
    category: "Field Evidence",
    image: evidenceMedia.monsoonCanalClogging,
    content: [
      "When monsoon rains hit dense urban centers, stormwater canals quickly become conveyors of massive volumes of unmanaged plastic packaging, bottles, and debris.",
      "Our field photo documentation reveals how severe the problem becomes when waste is allowed to travel downstream unchecked. Millions of pieces of plastic cluster into dense mats that obstruct water flow and lead to street-level flooding.",
      "Smart Drain's retrofit interception units are strategically placed at known hotspot segments to trap solid waste before it consolidates into system-wide choke points, protecting both the drainage infrastructure and recipient waterways.",
    ],
  },
  {
    slug: "secondary-drainage-channels-preventing-subsurface-debris-buildup",
    title: "Secondary drainage channels: intercepting waste before subsurface clogging",
    excerpt: "Why retrofitting confined concrete drains is critical to stopping plastic and packaging from entering closed underground conduits.",
    date: "September 20, 2026",
    readTime: "5 min read",
    category: "Infrastructure",
    image: evidenceMedia.openDrainWasteAccumulation,
    content: [
      "Secondary roadside channels and building perimeter drains are often the most overlooked culprits in municipal flooding disasters.",
      "Field inspections show that narrow open drains rapidly accumulate plastic sacks, food wrappers, and organic waste. When swept into underground culverts and piped conduits, this debris forms impenetrable subterranean plugs that require costly excavation to clear.",
      "By deploying modular Smart Drain retrofits at these perimeter channels, cities can maintain high hydraulic conveyance while capturing 100% of large debris right at surface level with easy access for maintenance.",
    ],
  },
  {
    slug: "kolonnawa-field-implementation-what-we-learned",
    title: "Kolonnawa field implementation: what real-world drainage tells us",
    excerpt: "How a 90 m urban drainage deployment is validating litter interception, stormwater flow and real-time monitoring under municipal conditions.",
    date: "September 24, 2026",
    readTime: "6 min read",
    category: "Deployments",
    image: kolonnawaMedia.completedInstallation,
    content: [
      "Smart Drain's first live municipal field implementation was launched in the Kolonnawa Urban Council area in Sri Lanka, across an approximately 90 m urban drainage section affected by repeated litter accumulation and clogging.",
      "The system is designed to intercept plastic, organic waste and other debris before it moves further through the drainage network while maintaining stormwater flow. Integrated IoT monitoring adds visibility into drainage conditions so operators can move from reactive cleaning toward earlier, better-targeted intervention.",
      "At one hotspot, 32 kg of plastic and organic waste was captured in a single week. The deployment is being used to build measurable evidence around litter interception, clog prevention, drainage performance, maintenance and operational response.",
    ],
  },
  {
    slug: "physical-protection-meets-digital-intelligence",
    title: "Physical protection meets digital intelligence",
    excerpt: "Why Smart Drain combines a retrofit litter-interception system with sensors, alerts and a live digital monitoring layer.",
    date: "September 17, 2026",
    readTime: "5 min read",
    category: "Technology",
    image: kolonnawaMedia.iotMonitor,
    content: [
      "Blocked drains are physical problems, but maintenance decisions are information problems. Smart Drain addresses both by combining debris interception with integrated sensing and monitoring.",
      "The physical layer keeps litter and debris from obstructing critical flow paths. The digital layer helps operators see water-level conditions, monitor maintenance indicators and receive alerts when intervention may be needed.",
      `The live digital platform is available at ${livePlatformUrl}, providing a foundation for remote visibility as field deployments scale across different drain types and operating environments.`,
    ],
  },
  {
    slug: "from-one-problem-site-to-a-scalable-pilot",
    title: "From one problem site to a scalable pilot",
    excerpt: "A practical framework for cities, councils and property owners to validate Smart Drain with site-specific KPIs before scaling.",
    date: "September 10, 2026",
    readTime: "5 min read",
    category: "Pilots",
    image: kolonnawaMedia.blockedDrain,
    content: [
      "A city does not need to replace an entire drainage network to test smarter stormwater management. A pilot can begin at one recurring problem site — a drain, street, precinct or corridor with persistent litter, clogging, maintenance demand or localised flooding.",
      "The pilot is then designed around measurable KPIs for litter interception, drainage performance, water-level monitoring, maintenance demand and operational response. A 12-month period allows seasonal conditions and maintenance cycles to be observed rather than relying on a one-day demonstration.",
      "The goal is straightforward: validate performance under the city's own drain geometry, rainfall, waste profile and operational constraints, then use the evidence to decide what should scale next.",
    ],
  },
  {
    slug: "smart-drain-development-roadmap-research-to-global-recognition",
    title: "Smart Drain's development roadmap: research to global recognition",
    excerpt: "From research and patent protection to international awards, accelerators and live field implementation.",
    date: "September 3, 2026",
    readTime: "7 min read",
    category: "Company",
    image: developmentMedia.wipo2025,
    content: [
      "Smart Drain's development journey spans research, invention, patenting, product design, international recognition, accelerator programs and live deployment.",
      "The technology received Australian Good Design recognition in 2024 and the WIPO Global Award in 2025. In 2026, Smart Drain was named ClimateLaunchpad Australia National Winner and advanced through UQ Ventures iLab and EnergyLab investment-readiness support.",
      "The next chapter is global validation: pilots with measurable KPIs, stronger deployment evidence and partnerships that can support manufacturing, materials, IoT and market scale-up.",
    ],
  },
]
